const SvgStack = (props) => (
  <svg height="1em" viewBox="0 0 16 16" width="1em" {...props}>
    <path
      d="M8 11.2l6.542-4.584L16 5.6 8 0 0 5.6l1.449 1.016L8 11.2zm0 2.032L1.44 8.648 0 9.656l8 5.6 8-5.6-1.449-1.016L8 13.232z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

export default SvgStack
